export default function Offer({ img }) {
  return (
    <div>
      <img src={img} alt="" />
    </div>
  );
}
